"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "timeline"
  }, _vm._l(_vm.list, function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "timeline-item"
    }, [_vm._m(0, true), _vm._v(" "), _c("div", {
      staticClass: "timeline-content",
      class: item.position
    }, [_vm._t("default", null, {
      item: item
    })], 2)]);
  }), 0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "timeline-icon"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/icons/protocol-send-client.png")
    }
  })]);
}];
render._withStripped = true;